import { css } from '@emotion/react';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import {
  TooltipBehavior, TooltipComponent,
} from '~/_shared/baseComponents/tooltip/tooltip.component';
import { LimitNumberOfLinesComponent } from '~/_shared/components/limitNumberOfLines/limitNumberOfLines.component';
import type { Theme } from '~/_shared/themes/theme.model';

const headingStyle = css({
  display: 'flex',
  flexDirection: 'column',
  fontSize: 12,
});

const entityWrapperStyles = css({
  maxWidth: '100%',
  minWidth: 0,
});

const mainEntityStyles = (theme: Theme) => css({
  color: theme.textColors.primary,
  fontSize: 10,
  display: 'flex',
  alignItems: 'center',
});

const subEntityStyles = (theme: Theme) => css({
  color: theme.textColors.primary,
  fontSize: 16,
  lineHeight: '18px', // to support underlined letters
  paddingTop: 1,
});

const boundaryNameStyles = (theme: Theme) => css({
  color: theme.textColors.secondary,
  fontSize: 12,
  paddingTop: 1,
});

const ellipsisStyle = css({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
});

const entityChevronStyle = css({
  paddingLeft: 4,
});

export const BoundaryKeyHeaderInfoComponent = ({
  mainEntity,
  shortenedSubEntity,
  boundaryTerritoryGroupName,
}: {
  shortenedSubEntity?: string;
  mainEntity?: string;
  boundaryTerritoryGroupName?: string;
}) => {

  if (!shortenedSubEntity) {
    shortenedSubEntity = mainEntity;
    mainEntity = undefined;
  }

  return (
    <div css={headingStyle}>
      <div css={entityWrapperStyles}>
        {mainEntity && (
          <div css={mainEntityStyles}>
            <div
              css={ellipsisStyle}
            >
              {mainEntity}
            </div>
            {shortenedSubEntity && (
              <FontAwesomeIcon
                css={entityChevronStyle}
                icon={faChevronRight}
                size="xs"
              />
            )}
          </div>
        )}
        {shortenedSubEntity && (
          <div
            css={[subEntityStyles]}
          >
            <TooltipComponent
              behavior={TooltipBehavior.ShowOnOverflow}
              delayShow={500}
              tooltipContent={shortenedSubEntity}
              overflowTolerance={{ x: 0, y: 3 }}
            >
              <LimitNumberOfLinesComponent maxNumberOfLines={2}>
                {shortenedSubEntity}
              </LimitNumberOfLinesComponent>
            </TooltipComponent>
          </div>
        )}
        {boundaryTerritoryGroupName && (
          <div
            css={[boundaryNameStyles]}
          >
            <TooltipComponent
              behavior={TooltipBehavior.ShowOnOverflow}
              delayShow={500}
              tooltipContent={boundaryTerritoryGroupName}
              overflowTolerance={{ x: 0, y: 3 }}
            >
              <LimitNumberOfLinesComponent maxNumberOfLines={1}>
                {boundaryTerritoryGroupName}
              </LimitNumberOfLinesComponent>
            </TooltipComponent>
          </div>
        )}
      </div>
    </div>
  );
};
